import { Stack, Caution, Icon, Text, Popover, PopoverContent, PopoverTrigger, Box } from '@cad-arc';
import { CautionsTabPill } from '@mark43/cad-api';
import { LinkText } from '../../common/components/link-text';
import { formatMonthDayYear } from '../../common/helpers/utils';
import { GeoCautionDto } from '@mark43/rms-api';
import { electronBridge } from '../../electron-bridge/electron-bridge';

export const CautionPill = ({
    caution,
    size,
}: {
    caution: CautionsTabPill | (GeoCautionDto & { cautionLevel: number });
    size?: 'sm' | 'md';
}) => {
    const pillCaution = caution as CautionsTabPill;
    const locationMapCaution = caution as GeoCautionDto & { cautionLevel: number };

    const { url, description, urlTitle } = caution;
    const { name, lastModifiedDateUtc, priorityLevel } = pillCaution;
    const { updatedDateUtc, cautionLevel, locationCautionAttrDisplay } = locationMapCaution;

    const cautionHasDescriptionOrLastUpdatedDate =
        !!description || !!lastModifiedDateUtc || !!updatedDateUtc;

    return (
        <Popover>
            <PopoverContent
                //Purposely making this not tabbable,
                // so that when you cycle through tabbing,
                // it goes to the next caution.
                // Without this, it will get focus trapped inside the popover
                tabIndex={undefined}
                style={{
                    cursor: 'text',
                    userSelect: 'text',
                }}
            >
                <Stack maxWidth="435px" data-testid="MAP_LOCATION_PIN_CAUTION_DETAILS_POPOVER">
                    {!!name && (
                        <Text variant="headingSm" as="span">
                            {name}
                        </Text>
                    )}
                    {cautionHasDescriptionOrLastUpdatedDate && (
                        <Stack direction="row">
                            {!!description && (
                                <Text fontSize="md" as="span">
                                    {description}
                                </Text>
                            )}
                            <Text fontSize="md" as="span">
                                {!!lastModifiedDateUtc && formatMonthDayYear(lastModifiedDateUtc)}
                                {!!updatedDateUtc && formatMonthDayYear(updatedDateUtc)}
                            </Text>
                        </Stack>
                    )}
                    {!!url && (
                        <LinkText
                            onClick={() => {
                                if (url) {
                                    if (electronBridge) {
                                        electronBridge.openUrlInBrowser(url);
                                    } else {
                                        window.open(url);
                                    }
                                }
                            }}
                        >
                            {urlTitle || 'Link'}
                        </LinkText>
                    )}
                </Stack>
            </PopoverContent>
            <PopoverTrigger asChild tabIndex={0}>
                <Caution
                    size={size ?? 'sm'}
                    style={{
                        cursor: 'pointer',
                    }}
                    priority={
                        (priorityLevel || cautionLevel || 4) as React.ComponentProps<
                            typeof Caution
                        >['priorities']
                    }
                    data-testid="MAP_LOCATION_PIN_CAUTION_PILL_BUTTON"
                >
                    <Stack direction="row" spacing={0} alignItems="center">
                        <Box style={{ lineHeight: 1 }} isTruncated={true}>
                            {!!name && name}
                            {!!locationCautionAttrDisplay && locationCautionAttrDisplay}
                        </Box>
                        {!!description && <Icon size="sm" icon="OpenRight" />}
                    </Stack>
                </Caution>
            </PopoverTrigger>
        </Popover>
    );
};
